module.exports = __webpack_public_path__ + "static/faq_shape_4-bf628c9d08e25b1784b23f5457f1b843.svg";